// import { Abilities  } from '@casl/ability'
import { initialAbility } from './config'
import { createMongoAbility } from '@casl/ability'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
const userData = localStorage.getItem('authUser');
const existingAbility = userData ? JSON.parse(userData).ability : null
export default new createMongoAbility  (existingAbility || initialAbility)
